<template>
	<div class="news">
		<div class="innerhdon">
			<innerhd :show ='show'  ref='header'/>
		</div>
		<div class="innerCon">
			<div class="innerbanner">
				<a href="#"><img :src="newsBanner" /></a>
			</div>
			<div class="bgcolor newsPage">
				<div class="wrapper clearfix">
					<!--<div class="flBlock">-->
						<!--<titKind :kindlst="kindlst" />-->
						<div class="scrollWrap" >
							<swiper :options="swiperOption">
								<swiper-slide  v-for="item in List" :key="item.index">
									<div class="item clearfix"  style="width:500px" @click="goinfo(item)" >
										<!-- <div class="pic">
											<img  src="../assets/img/img12.jpg" />
										</div> -->
										<div class="txt">
											<h5 v-html="item.name"></h5>
											<div class="min">
												<dl>
													<dd>成立日期：{{item.estiblishTime}}</dd>
													<dd>所属企业：<span v-html="item.name"></span></dd>
												</dl>
											</div>
										</div>
									</div>
								</swiper-slide>
								<div class="swiper-pagination"></div>
							</swiper>
						</div>
						<!-- <div class="queryBox">
							<div class="padingbox">
								<div class="box">
									<strong>搜索范围：</strong>
									<div class="lst">
										<span>企业名称</span>
										<span>股东</span>
										<span>法人</span>
										<span>高管</span>
										<span>联系方式</span>
										<span>经营范围</span>
										<span>网址 </span>
										<span>商标</span>
										<span>专利 </span>
										<span>作品著作权</span>
										<span>软件著作权 </span>
									</div>
								</div>
								<div class="box">
									<strong>成立年限：</strong>
									<div class="lst">
										<span>成立1年内</span>
										<span>成立1-5年</span>
										<span>成立5-10年</span>
										<span>成立10-15年</span>
										<span>成立15年以上</span>
										<span class="blue">自定义时间</span>
									</div>
								</div>
								<div class="box">
									<strong>注册资本：</strong>
									<div class="lst">
										<span>0万 - 100万</span>
										<span>100万 - 200万</span>
										<span>200万 - 500万</span>
										<span>500万 - 1000万</span>
										<span>1000万以上</span>
										<span class="blue">自定义金额</span>
									</div>
								</div>
								<div class="box">
									<strong>组织类型：</strong>
									<div class="lst">
										<span>新三板</span>
										<span>上市公司  </span>
										<span>社会组织</span>
										<span>律师事务所</span>
										<span>香港企业 </span>
										<span>高新企业</span>
									</div>
								</div>
								<div class="box boxPad">
									<strong>省份：</strong>
									<div class="lst">
										<span>北京</span>
										<span>上海 </span>
										<span>天津</span>
										<span>重庆 </span>
										<span>江苏 </span>
										<span>广东  </span>
										<span>河北 </span>
										<span>河南 </span>
										<span>安徽 </span>
										<span>浙江 </span>
										<span>福建 </span>
										<span>甘肃 </span>
										<span>广西 </span>
									</div>
									<div class="moreBtn">更多<img :src="arrow" /></div>
								</div>
								<div class="box boxPad">
									<strong>行业：</strong>
									<div class="lst">
										<span>农、林、牧、渔业</span>
										<span>采矿业  </span>
										<span>制造业</span>
										<span>电力、热力、燃气及水生产和供应业 </span>
										<span>批发和零售业 </span>
									</div>
									<div class="moreBtn">更多<img :src="arrow" /></div>
								</div>
							</div>
							<div class="moreQuery">展开更多筛选<img :src="j_b" /></div>
						</div> -->
						<div class="reasultLst" v-if="this.total>0">
							<div class="top clearfix">
								<div class="fl">为您找到 <strong>{{total}}</strong> 条相关结果</div>
								<div class="fr">
									<span class="raking blue">默认排序<!--<img :src="arrow" />--></span>
									<span class="export"><img :src="dc" />数据导出</span>
								</div> -->
							</div>
							<div class="lst">
								<!--循环数据-->
								<ul>
									<li v-for="item in List " :key="item.index">
										<div class="item clearfix">
											<!-- <div class="pic">
												<img src="../assets/img/img12.jpg" />
											</div> -->
											<div class="txt" @click="goinfo(item)">
												<h5  v-html="item.name"></h5>
												<div class="info">
													<span style="color:#1e90ff"><strong>法定代表人：</strong>{{item.legalPersonName}}</span>
													<span><strong>注册资本：</strong>{{item.regCapital}}</span>
													<span><strong>成立时间：</strong> {{item.estiblishTime}}</span>
												</div>
											</div>
										</div>
										<button :class="[item.regStatus == '注销' ? 'contactItOn':'contactIt']">
														{{item.regStatus}}
									   </button>
									</li>
								</ul>
							</div>
							<paging v-if="totalPages>0"  :total='totalPages' @pageing='listArticle' />
						</div>
					</div>
					<div class="frBlock">
						<!-- <innerFr className="recommend" innerFrtit="翰林推荐" :adImg='adImg'  :hotNews="hotNews" /> -->
					</div>
				<!--</div>-->
			</div>
		</div>
		<foot />
		<rightFix />
	</div>
</template>
<script>
import newsBanner from '@/assets/img/infoBaner.jpg'
//import arrow from '@/assets/img/arrow.png'
import dc from '@/assets/img/dc.png'
import j_b from '@/assets/img/j_b.png'

//		import titKind from '@/components/titKind.vue'
import innerhd from '@/components/innerHd.vue'
import foot from '@/components/foot.vue'
import rightFix from '@/components/rightFix.vue'
import innerFr from '@/components/innerFr.vue'
import paging from '@/components/paging.vue'
import testjosn from '@/assets/test.js'
export default {
  name: 'enterpriseInfo',
  components: {
//  arrow,
    dc,
    j_b,
    foot,
    rightFix,
    innerhd,
    innerFr,
    paging,
    //			titKind,
    newsBanner
  },
  data () {
    return {
      // 根据企业名称查询出来的结果
	  queryByParams: [],
	  rename:'',
	  param:'',
	  param2:'',
	  // 从首页输入框传过来的值
	  name:'',
	  // 从子组件输入框调用过来的参数
	  childName:'',
      queryParams: {
        pageNum: 1,
        pageSize: 2
      },
      total: 0,
      List: [],
      totalPages: '',
      show: true,
//    arrow,
      dc,
      j_b,
      newsBanner,
      swiperOption: {
    	  autoplay: {
	         delay: 5000,
	         stopOnLastSlide: false,
	         disableOnInteraction: true
	       },
        slidesPerView: 2,
        autoplay: true,
        initialSlide: 0,
        spaceBetween: 20
      },
      adImg: [{
        imgSrc: require('@/assets/img/img7.jpg')
      }, {
        imgSrc: require('@/assets/img/img8.jpg')
      }],
      hotNews: []
    }
  },
  created () {
	  this.searchHomeInfo()
  },
  mounted() {
   this.childName = this.$refs.header.name
  },
  methods: {
    goinfo (item) { // 跳转到详情页
	  this.rename = item.name.replace(/<[^>]+>/g,"")
	//   this.param = { id: item.id, name: this.rename }
	//   this.param2 = { businessId: item.id, name: this.rename}
	  const href = this.$router.resolve({
			name:'enterpriseInfoDeatl',
			params:{
				param: JSON.stringify({ id: item.id, name: this.rename }),
				param2: JSON.stringify({ businessId: item.id, name: this.rename})
			}
		})
       window.open(href.href,'_blank')
    },
    selectMemberInfo () { // 根据输入框的数量的公司名称进行模糊查询
      // 调用子组件传过来的属性（得到input框输入的企业名称）
      const params = { name: this.$refs.header.name }
	  // 调用模糊查询的接口 根据企业名称查询
      this.$api.getBusinessListByName(params).then(response => {
        if (response.code === 200) {
          this.List = response.data.result.items
          this.id = this.List.id
          this.name = this.List.name
		  this.total = this.List.length
        }else if(response.code === 401){
			this.$alert("登录状态已过期,请重新登录！")
		}else {
			this.$message(response.msg)	
		}
      })
	},
	searchHomeInfo () {
		this.name = this.$route.params.inputInfo
		if(this.name !==''){
		// 将子组件的值变成从首页输入框输入的值
		this.childName = this.name
		// 调用子组件传过来的属性（得到input框输入的企业名称）
		const params = { name: this.name }
		// 调用模糊查询的接口 根据企业名称查询
		this.$api.getBusinessListByName(params).then(response => {
			if (response.code === 200) {
			this.List = response.data.result.items
			this.id = this.List.id
			this.name = this.List.name
			this.total = this.List.length
        }
      })
		}
	}
  }
}
</script>
<style scoped lang="scss">
 .contactItOn {
            display: inline-block;
            *display: inline;
            zoom: 1;
            text-align: center;
            width: 98px;
            height: 40px;
            line-height:40px;
            font-size: 16px;
            color: #fff;
            background: #ff4949;
            border-radius: 4px;
            position: absolute;
            top: 50%;
            margin-top:-20px;
            right: 20px;
            border:none;
        }
</style>
